import MainLayout from "@/layout/MainLayout.vue"
import Login from "@/login/Login.vue"
import DashboardView from "@/DashboardView.vue"
import NominatedBeneficiaryView from "@/superannuation/NominatedBeneficiaryView.vue"
import SuperScoreView from "@/superannuation/SuperScoreView.vue"
import AnalyticsView from "@/superannuation/AnalyticsView.vue"
import RetirementAdequacyView from "@/superannuation/RetirementAdequacyView.vue"
import AccountBalanceView from "@/superannuation/AccountBalanceView.vue"
import InvestmentApproachView from "@/superannuation/InvestmentApproachView.vue"
import LifeInsuranceView from "@/superannuation/LifeInsuranceView.vue"
import ResetPassword from "@/login/ResetPassword.vue"
import DashboardReport from "@/report/DashboardReport.vue"
import PolicyCommitteeReport from "@/report/PolicyCommitteeReport.vue"
import MembersView from "@/superannuation/MembersView.vue"
import MemberEventsView from "@/staff/MemberEventsView.vue"

export const staticRoutes = [
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/login",
    component: Login,
    meta: {
      unauthenticatedAccess: true,
    },
  },
  {
    path: "/reset-password",
    component: ResetPassword,
    meta: {
      unauthenticatedAccess: true,
    },
  },
  {
    path: "/report",
    component: DashboardReport,
  },
  {
    path: "/policyCommitteeReport",
    component: PolicyCommitteeReport,
  },
  {
    path: "/",
    component: MainLayout,
    meta: {
      nav: true,
      title: "Home",
    },
    children: [
      {
        path: "dashboard",
        component: DashboardView,
        meta: {
          restoreScrollPosition: true,
        },
      },
    ],
  },
  {
    path: "/super",
    component: MainLayout,
    meta: {
      nav: true,
      title: "Super",
    },
    children: [
      {
        path: "nominatedBeneficiary",
        component: NominatedBeneficiaryView,
      },
      {
        path: "accountBalance",
        component: AccountBalanceView,
      },
      {
        path: "investmentApproach",
        component: InvestmentApproachView,
      },
      {
        path: "lifeInsurance",
        component: LifeInsuranceView,
      },
      {
        path: "retirementAdequacy",
        component: RetirementAdequacyView,
      },
      {
        path: "superScore",
        component: SuperScoreView,
      },
      {
        path: "analytics/:metric",
        component: AnalyticsView,
      },
      {
        path: "analytics",
        component: AnalyticsView,
      },
      {
        path: "members",
        component: MembersView,
      },
      {
        path: "memberEvents",
        component: MemberEventsView,
      },
    ],
  },
]
